import { render, staticRenderFns } from "./OrderBlock.vue?vue&type=template&id=b6dd54ae&"
import script from "./OrderBlock.vue?vue&type=script&lang=js&"
export * from "./OrderBlock.vue?vue&type=script&lang=js&"
import style0 from "./OrderBlock.vue?vue&type=style&index=0&id=b6dd54ae&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports